// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2CpOy","label":"Section_label__DnXvQ","contentWrap":"Section_contentWrap__2cRfr","footer":"Section_footer__1KP3z","footerInner":"Section_footerInner__3Ai0d"};